import { FormikConfig, useFormik, FormikProvider } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ModalWindowV2 } from "src/components/ModalWindowV2";
import { ModalState } from "src/hooks/useModal";
import { RenderFormFields } from "src/components/RenderFormFields";
import { IPasswordResetValues } from "src/@types/auth";
import {
  PASSWORD_RESET_FORM_FIELDS,
  PASSWORD_RESET_VALIDATION_SCHEMA,
} from "./constants";
import { resetPasswordPopupTrns } from "./trns";
import { AuthFormButton } from "../AuthFormButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { resetPasswordAsync } from "src/redux/auth/actions";
import { selectIsLoading } from "src/redux/auth/selectors";

const INITIAL_VALUES = {
  email: "",
};

interface Props extends ModalState {}

export const PasswordResetPopup: FC<Props> = ({ ...modalProps }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);

  const formikProps: FormikConfig<IPasswordResetValues> = {
    initialValues: INITIAL_VALUES,
    validationSchema: PASSWORD_RESET_VALIDATION_SCHEMA,
    onSubmit: (values, { resetForm }) => {
      dispatch(
        resetPasswordAsync({
          values,
          onSuccess: () => {
            modalProps.closeModal();
            resetForm();
          },
        })
      );
    },
  };

  const formik = useFormik<IPasswordResetValues>(formikProps);

  return (
    <ModalWindowV2
      {...modalProps}
      className="max-w-80 w-full"
      isActiveCloseClickOutside={false}
      isShownCloseButton
      isActivePortal
    >
      <FormikProvider value={formik}>
        <form className="flex flex-col gap-9 p-5 bg-white-base border border-gray-base/20 rounded-20">
          <h3 className="font-semibold text-center">
            {t(resetPasswordPopupTrns.title)}
          </h3>
          <p className="text-sm text-justify">{t(resetPasswordPopupTrns.description)}</p>
          <div>
            <RenderFormFields fields={PASSWORD_RESET_FORM_FIELDS} />
          </div>
          <AuthFormButton isLoading={isLoading} className="min-h-11">
            {t(resetPasswordPopupTrns.sendInstructionsButton)}
          </AuthFormButton>
        </form>
      </FormikProvider>
    </ModalWindowV2>
  );
};
